"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayVerticalNav = ClayVerticalNav;

var _core = require("@clayui/core");

var _react = _interopRequireDefault(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _excluded = ["activeLabel", "children", "displayType", "triggerLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ClayVerticalNav(_ref) {
  var activeLabel = _ref.activeLabel,
      children = _ref.children,
      displayType = _ref.displayType,
      _ref$triggerLabel = _ref.triggerLabel,
      triggerLabel = _ref$triggerLabel === void 0 ? 'Menu' : _ref$triggerLabel,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  "production" !== "production" ? (0, _warning.default)(!activeLabel, 'ClayVerticalNav: The `activeLabel` API has been deprecated in favor of `triggerLabel` and will be removed in the next major release.') : void 0;

  if (children && !displayType) {
    return /*#__PURE__*/_react.default.createElement(_core.VerticalNav, _extends({}, otherProps, {
      triggerLabel: activeLabel !== null && activeLabel !== void 0 ? activeLabel : triggerLabel
    }), children);
  }

  return /*#__PURE__*/_react.default.createElement(_core.VerticalNav, _extends({}, otherProps, {
    triggerLabel: activeLabel !== null && activeLabel !== void 0 ? activeLabel : triggerLabel
  }), function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.VerticalNav.Item, {
      active: item.active,
      href: item.href,
      initialExpanded: item.initialExpanded,
      items: item.items,
      onClick: item.onClick
    }, item.label);
  });
}

ClayVerticalNav.Trigger = _core.VerticalNav.Trigger;
ClayVerticalNav.Item = _core.VerticalNav.Item;